import { handleActions } from 'redux-actions';
import { SET_CONNECTIONS_ORDER_BY } from './actions';

const initialState = {
  connectionsOrderBy: {
    orderDir: 'desc',
    keyName: 'updatedAt',
  },
};

export const setConnectionsOrderBy = (state, { payload }) => {
  const { connectionsOrderBy } = payload;

  return {
    ...state,
    connectionsOrderBy,
  };
};

const mappedReducers = {
  [SET_CONNECTIONS_ORDER_BY]: setConnectionsOrderBy,
};

const mailchimpConnectionsTableState = handleActions(
  mappedReducers,
  initialState,
);

export default mailchimpConnectionsTableState;
